import React from 'react';
import { GameStore, PlatformFamily } from '../product/types';

export interface OfferForm {
  id?: number;
  region: 'India' | 'Turkey' | 'CIS' | null;
  fulfillmentType: 'PersonalPurchase' | 'SharedAccount';
  activationType: 'Included' | 'NotIncluded' | 'NotApplicable';
  price: string;
}

export const emptyOffers = (): OfferForm[] => [
  { region: 'India', fulfillmentType: 'PersonalPurchase', activationType: 'NotApplicable', price: '' },
  { region: 'Turkey', fulfillmentType: 'PersonalPurchase', activationType: 'NotApplicable', price: '' },
  { region: 'CIS', fulfillmentType: 'PersonalPurchase', activationType: 'NotApplicable', price: '' },
  { region: null, fulfillmentType: 'SharedAccount', activationType: 'Included', price: '' },
  { region: null, fulfillmentType: 'SharedAccount', activationType: 'NotIncluded', price: '' },
];

const offerLabel = (o: OfferForm) => o.fulfillmentType === 'SharedAccount'
  ? `Шеринг — ${o.activationType === 'Included' ? 'с активацией' : 'без активации'}`
  : ({ India: 'Индия', Turkey: 'Турция', CIS: 'СНГ' }[o.region!]);

export const GameCommerceFields = ({ family, store, offers, onFamilyChange, onStoreChange, onOffersChange, compact = false }: {
  family: PlatformFamily | '';
  store: GameStore | '';
  offers: OfferForm[];
  onFamilyChange: (value: PlatformFamily | '') => void;
  onStoreChange: (value: GameStore | '') => void;
  onOffersChange: (value: OfferForm[]) => void;
  compact?: boolean;
}) => (
  <section className="sm:col-span-2 space-y-5 rounded-2xl border border-gray-200 bg-gray-50/60 p-4 sm:p-5">
    {!compact && <div>
      <h3 className="text-sm font-semibold text-gray-900">Продажа и варианты покупки</h3>
      <p className="mt-1 text-xs text-gray-500">Магазин определяет доступные способы покупки. Региональные цены доступны только для PlayStation Store.</p>
    </div>}
    {!compact && <div className="grid gap-4 sm:grid-cols-2">
      <label><span className="mb-1 block text-sm font-medium text-gray-700">Семейство платформ</span>
        <select value={family} onChange={e => onFamilyChange(e.target.value as PlatformFamily | '')} className="w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-3 text-sm text-gray-900 outline-none focus:border-gray-400 focus:bg-white">
          <option value="">Не указано</option><option value="PlayStation">PlayStation</option><option value="Xbox">Xbox</option><option value="Nintendo">Nintendo</option><option value="PC">PC</option>
        </select>
      </label>
      <label><span className="mb-1 block text-sm font-medium text-gray-700">Магазин</span>
        <select value={store} onChange={e => onStoreChange(e.target.value as GameStore | '')} className="w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-3 text-sm text-gray-900 outline-none focus:border-gray-400 focus:bg-white">
          <option value="">Не указан</option><option value="PlayStationStore">PlayStation Store</option><option value="MicrosoftStore">Microsoft Store</option><option value="NintendoEshop">Nintendo eShop</option><option value="Steam">Steam</option><option value="Other">Другой</option>
        </select>
      </label>
    </div>}
    {store === 'PlayStationStore' && (
      <fieldset className="rounded-xl border border-gray-200 bg-white p-4"><legend className="px-2 text-sm font-semibold text-gray-700">{compact ? 'Цены издания по регионам и шерингу' : 'Цены PlayStation Store'}</legend>
        <p className="mb-3 text-xs text-gray-500">Пустая цена скрывает предложение. Цена каталога определяется автоматически как минимальная.</p>
        <div className="grid gap-4 sm:grid-cols-2">
          {offers.map((offer, index) => <label key={`${offer.region}-${offer.activationType}`}>
            <span className="mb-1 block text-xs font-medium text-gray-600">{offerLabel(offer)}</span>
            <div className="relative"><input inputMode="decimal" value={offer.price} onChange={e => onOffersChange(offers.map((o, i) => i === index ? { ...o, price: e.target.value } : o))} placeholder="Не продаётся" className="w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-3 pr-10 text-sm text-gray-900 caret-gray-900 outline-none placeholder:text-gray-400 focus:border-gray-400 focus:bg-white" /><span className="pointer-events-none absolute right-4 top-3 text-sm text-gray-400">₽</span></div>
          </label>)}
        </div>
      </fieldset>
    )}
    {!compact && store !== 'PlayStationStore' && <p className="rounded-xl border border-dashed border-gray-200 bg-white px-4 py-3 text-xs text-gray-500">Для выбранного магазина используется базовая цена карточки.</p>}
  </section>
);
